import { render, staticRenderFns } from "./ResultadoConsulta.vue?vue&type=template&id=cc390c50&scoped=true"
import script from "./ResultadoConsulta.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResultadoConsulta.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ResultadoConsulta.vue?vue&type=style&index=0&id=cc390c50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc390c50",
  null
  
)

export default component.exports